import { combineReducers } from "redux";
import loginReducer from "./Reducers/auth/login-reducer";
import logoutReducer from "./Reducers/auth/logout-reducer";
import profileReducer from "./Reducers/profile/profile-reducer";
import userManagementReducer from "./Reducers/user-management/user-management-reducer";
import cmsReducer from "./Reducers/cms/cms-reducer";
import settingsReducer from "./Reducers/settings/settings-reducer";
import dashboardReducer from "./Reducers/dashboard/dashboard-reducer";
import changePasswordReducer from "./Reducers/profile/change-password-reducer";
import forgetPasswordReducer from "./Reducers/auth/forget-password-reducer";
import resetPasswordReducer from "./Reducers/auth/reset-password-reducer";
import categoryManagementReducer from "./Reducers/category-management/category-management-reducer";
import curriculumManagementReducer from "./Reducers/curriculum-management/curriculum-management-reducer"
import productManagementReducer from "./Reducers/product-management/product-management-reducer";
import mainModuleManagementReducer from "./Reducers/product-management/product-management-reducer";
import schoolManagementReducer from "./Reducers/school-management/school-management-reducer";
import exportManagementReducer from "./Reducers/school-management/export-reducers";
import codeManagementReducer from './Reducers/code-management/code-management-reducer'
import headingManagementReducer from "./Reducers/heading/heading-management-reducers";
import glbFileReducer from "./Reducers/glb-upload/glb-reducer";
import jsonFileReducer from "./Reducers/json-upload/json-reducer";
import viewJsonFileReducer from "./Reducers/json-view/viewjson-reducer";
import ModuleReducer from "./Reducers/module/module-reducer";
import ModuleListReducer from "./Reducers/module/moduleListing-reducer";
import PermissionReducer from "./Reducers/permission/permission-reducer";

const rootReducer = combineReducers({
    loginReducer,
    logoutReducer,
    profileReducer,
    userManagementReducer,
    cmsReducer,
    settingsReducer,
    dashboardReducer,
    changePasswordReducer,
    forgetPasswordReducer,
    resetPasswordReducer,
    categoryManagementReducer,
    curriculumManagementReducer,
    productManagementReducer,
    mainModuleManagementReducer,
    schoolManagementReducer,
    exportManagementReducer,
    codeManagementReducer,
    headingManagementReducer,
    glbFileReducer,
    jsonFileReducer,
    viewJsonFileReducer,
    ModuleReducer,
    ModuleListReducer,
    PermissionReducer
});

export default rootReducer;

